import styled from 'styled-components';

export const Container = styled.div`
display: grid;
grid-template-columns: repeat(4, 1fr);
    height: auto;
    row-gap: 20px;
    column-gap: 20px;
    margin: auto;
    margin-bottom: 30px;
    > * {
        margin-left: 20px;
    }
}
`;

export const Description = styled.div`
    font-weight: 400;
    color: #6b6b6b;
    font-size: 1.0em;
`;
